"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TimesCircleSolid_1 = __importDefault(require("../IconsNavigation/TimesCircleSolid"));
const styled_1 = require("./styled");
class Modal extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: true,
        };
    }
    open() {
        const { callback } = this.props;
        this.setState({ hidden: false });
        if (typeof callback === "function")
            callback({ action: "open" });
    }
    close() {
        const { callback } = this.props;
        this.setState({ hidden: true });
        if (typeof callback === "function")
            callback({ action: "close" });
    }
    render() {
        const { children, lockScroll = true, overlayClose = true, width = 500, closer = true, disableScroll = false, closeButton = { top: 10, right: 10, icon: react_1.default.createElement(TimesCircleSolid_1.default, { height: 30 }) } } = this.props;
        const { hidden } = this.state;
        if (hidden)
            return react_1.default.createElement(react_1.default.Fragment, null);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styled_1.LockScroll, { locked: lockScroll }),
            react_1.default.createElement(styled_1.Overlay, { id: "overlay", hidden: hidden, onClick: (e) => {
                    if (overlayClose && e.target.id === "overlay")
                        this.close();
                } },
                react_1.default.createElement(styled_1.Inner, { id: "inner", width: width, disableScroll: disableScroll },
                    children,
                    closer ? (react_1.default.createElement(styled_1.Closer, { onClick: () => this.close(), top: closeButton.top, right: closeButton.right }, closeButton.icon)) : null))));
    }
}
exports.default = Modal;
//# sourceMappingURL=Modal.js.map